/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationRenamePathParams,
	OrganisationRenameRequest,
	OrganisationRenameResponse,
} from '../types/OrganisationRename'

/**
 * PATCH /organisations/:organisation/name
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::rename
 */
export async function organisationRename(
	organisation: OrganisationRenamePathParams['organisation'],
	data: OrganisationRenameRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationRenameResponse>> {
	return axiosInstance.patch(`/organisations/${organisation}/name`, data, config)
}
